/** The guide's five named levels, shared by anchors, readback and interactive score targets. */
export const SCORE_LABEL: Record<string, string> = { "5": "Exceptional", "4": "Exceeds requirement", "3": "Meets requirement", "2": "Below requirement", "1": "Significant gap" };
export function ScoreCircle({ score }: { score: string | number }) {
  return <span className="score-circle" aria-hidden="true">{score}</span>;
}
export function RatingLadder({ anchors }: { anchors: Record<string, string> }) {
  return <dl className="rating-ladder" aria-label="Rating scale, five to one">{[5, 4, 3, 2, 1].map(score => <div key={score} className={`rating-ladder__level rating-tone--${score}`}>
    <dt><ScoreCircle score={score} /><span className="sr-only">{score} · </span>{SCORE_LABEL[String(score)]}</dt>
    <dd>{anchors[String(score)] ?? "Use the assigned skill's observations to support this rating."}</dd>
  </div>)}</dl>;
}
